import streetlightsLogo from '../images/streetlights-logo.png';
import { useRecoilValue } from 'recoil';
import { configState } from '../recoil/atoms';

const AppLogo = ({ className }: { className: string }) => {
  const configContext = useRecoilValue(configState);
  return (
    <img
      src={(configContext.theme.logoUrl.length > 0 && configContext.theme.logoUrl) || streetlightsLogo}
      alt="logo"
      className={className}
    />
  );
};

export default AppLogo;
